import React, { useEffect, useRef } from 'react';
import styles from './modal.module.scss';
import { c, mergeRefs } from '../../utils';
import { IconButton } from '../IconButton';
import PropTypes from 'prop-types';
import { FocusBackground } from '../FocusBackground';

export const Modal = React.forwardRef(({ children, className, show, onClose, disableAnimation, ...props }, ref) => {
  const callClose = () => onClose && onClose();
  const modalRef = useRef(null);

  useEffect(() => {
    if (show) {
      modalRef.current.scrollIntoView();
    }
  }, [show, ref, modalRef]);

  return (
    <>
      <FocusBackground show={show} onClick={callClose} />
      <div
        id="modal"
        className={c(
          styles.modal,
          show && styles.show,
          disableAnimation && styles.disableAnimation,
          className
        )}
        ref={mergeRefs(modalRef, ref)}
        {...props}
      >
        <div className={styles.topBar}>
          <IconButton
            className={styles.closeButton}
            name='remove_cross'
            onClick={callClose}
            variant='link'
          />
        </div>

        {children}
      </div>
    </>
  );
});

Modal.propTypes = {
  /**
   * Whether to show the modal
   */
  show: PropTypes.bool,
  /**
   * Called when a close action is called
   */
  onClose: PropTypes.func,
  /**
   * Flag to disable animation
   */
  disableAnimation: PropTypes.bool,

  modalRef: PropTypes.element
};
